export const navigationEn: Record<string, string> = {
  'main': 'Main',
  'administration': 'Administration',
  'toggle_sidebar': 'Toggle Sidebar',
  'search_customers_orders': 'Search customers, orders...',
  'dashboard': 'Dashboard',
  'leads': 'Leads',
  'products': 'Products',
  'appointments': 'Appointments',
  'appointments_v2': 'Appointments',
  'appointments_v2_description': 'Manage your appointments with calendar views and features',
  'measurements': 'Measurements',
  'orders': 'Orders',
  'orders.title': 'Orders',
  'sales': 'Sales',
  'invoices': 'Invoices',
  'payment_requests': 'Payment Requests',
  'payments': 'Payments',
  'invoices_payments': 'Invoices & Payments',
  'alterations': 'Alterations',
  'reports': 'Reports',
  'suppliers': 'Suppliers',
  'inventory': 'Inventory',
  'job_centre': 'Job Centre',
  'settings': 'Settings',
  'wishlist': 'Wishlist',
  'loyalty': 'Loyalty',
  'help': 'Help & Tips',
  'sign_out': 'Sign out',
  'import_history': 'Import History',
  'search_mobile': 'Search...',
  'welcome_back': 'Welcome back',
  'language_toggle': 'Switch language',
  'menu': 'Menu',
  'close_menu': 'Close menu',
  'user_menu': 'User menu',
  'my_bridal_journey': 'My Bridal Journey',
};
